import { render, staticRenderFns } from "./LayoutSider.vue?vue&type=template&id=34c78a81&scoped=true&"
import script from "./LayoutSider.vue?vue&type=script&lang=js&"
export * from "./LayoutSider.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSider.vue?vue&type=style&index=0&id=34c78a81&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c78a81",
  null
  
)

export default component.exports